export default {
    layout: {
        loading: 'جاري التداول',
        trading: 'جاري التداول'
    },
    footer: {
    },
    menu: {
        home: 'الصفحة الرئيسية',
        staking: 'المصفوفة',
        port: 'PORT',
        internet: 'الشبكة',
        me: 'حسابي'
    },
    header: {
        selectLang: 'اختر اللغة',
        close: 'إغلاق',
        trading: 'تداول',
        dashboard: 'لوحة التحكم',
        subscribeMatrix: 'اشتراك في المصفوفة',
        portTaskCenter: 'مركز مهام PORT',
        network: 'الشبكة',
        apiBinding: 'ربط API',
        gridTree: 'شجرة الشبكة',
        account: 'الحساب',
        documents: 'المستندات و الورقة البيضاء',
        personalCenter: 'المركز الشخصي',
        language: 'اللغة'
    },
    home: {
        recently1:'المجتمع',
        staticrewares: 'ثابت',
        recentlyName: 'دفتر الحسابات',
        recentlyInfo: 'تفاصيل الأرباح',
        dataUpdate: 'تحديث البيانات',
        realtime: 'الوقت الفعلي · BSC',
        totalRevenue: 'إجمالي الأرباح (USDT)',
        today: 'اليوم',
        totalTradingVolume: 'إجمالي حجم التداول',
        todayEarn: 'مكاسب اليوم',
        share: 'شارك مع الأصدقاء',
        shareDesc: 'اعرض أرباحك وادعُ الأصدقاء للحصول على المكافآت',
        directReferrals: 'عدد الإحالات المباشرة',
        teamMembers: 'عدد أعضاء الفريق',
        thisWeek: 'هذا الأسبوع',
        copy: 'نسخ',
        recently: 'الأرباح الأخيرة',
        netIncome: 'صافي الدخل',
        dailyAverage: 'المعدل اليومي',
        quantitativeIncome: 'الأرباح الكمية',
        recommend: 'توصية',
        port: 'PORT',
        bonus: 'مكافأة',
        all: 'الكل',
        todayTitle: 'اليوم',
        loadingMore: 'تحميل المزيد',
        recommendBonus: 'مكافأة الإحالة',
        portTaskPassed: 'تم اجتياز مهمة PORT',
        myProfit: 'أرباحي',
        earningOnBitDeep: 'أربح على BitDeep',
        totalRevenueUsdt: 'إجمالي الأرباح · USDT',
        consecutiveDays: 'أيام متتالية',
        scanToJoin: 'امسح للانضمام',
        uid: 'UID',
        referralBonus: 'مكافأة الإحالة',
        shareTo: 'شارك إلى',
        eachReferral: 'مكافأة المشاركة',
        screenshotAndShare: 'التقط صورة وشاركها',
        saveShareEarn: 'احفظ · شارك · اربح',
        period: 'الفترة',
        netProfit: 'صافي الربح',
        quantReward: 'مكافأة كمية',
        dailyBonus: 'مكافأة PORT اليومية',
        close: 'إغلاق',
        permission: 'إذن',
        onlyEnable: 'تشغيل فقط',
        enterBitgetUid: 'أدخل BITGET UID',
        slogan: 'شعار',
        document: 'مستند',
        days: 'أيام',
        taskText: 'مهمة',
        minutes: 'دقائق',
        decentralizedPortTech: 'بنية تقنية PoRT اللامركزية، اقتصاد رمز BGB، ومصفوفة الحوافز المزدوجة.',
        auditReport: 'تقرير التدقيق',
        faqSupport: 'الأسئلة الشائعة والدعم',
        telegram: 'Telegram',
        piece: 'جزء',
        faq: 'الأسئلة الشائعة',
       faq1: 'كيف أربط Bitget API؟',
        faq1Desc: 'ادخل إلى منصة Bitget ← الإعدادات ← إدارة API للحصول على API Key وSecret. فعّل صلاحية التداول الفوري (Spot) فقط، وممنوع منعًا باتًا تفعيل صلاحية السحب. الصق المفاتيح في BitDeep DApp، وبعد إتمام صفقة اختبار بقيمة 1 USDT يتم تفعيل الربط.',
        faq2: 'ما هو PoRT (إثبات التداول الحقيقي)؟',
        faq2Desc: 'PoRT هو الآلية الجوهرية لمفهوم "التداول كتعدين". كل يوم يقوم النظام تلقائيًا عبر Bitget API بتنفيذ صفقات شراء وبيع سريعة على عملة محددة (مثل BGB). عندما يتجاوز حجم التداول قيمة الإيداع × 50%، يتحقق النظام ويُطلق مكافأة اليوم.',
        faq3: 'هل أحتاج إلى مراقبة السوق يدويًا كل يوم؟',
        faq3Desc: 'لا حاجة لذلك. بعد ربط API يقوم النظام تلقائيًا بإكمال مهام التداول خلال نافذة 24 ساعة. لا تحتاج لأي إجراء يدوي؛ يمكنك التحقق من قائمة PoRT.',
        faq4: 'ما الفرق بين ALPHA و SIGMA؟',
        faq4Desc: 'ALPHA (مبتدئ): إيداع 500 USDT، عائد يومي 0.3–1.3%، خطة واحدة فقط. SIGMA (احترافي): إيداع 1,000 USDT، عائد يومي 0.6–1.6%، حتى 5 خطط.',
        faq5: 'هل أموالي آمنة؟ هل يمكن للمنصة التصرف في أموالي؟',
        faq5Desc: 'تبقى أموالك 100% في حسابك على Bitget. يمنح API صلاحيات القراءة والتداول الفوري فقط؛ لا يمكن للنظام سحب أو تحويل أي رأس مال.',
        faq6: 'متى تتم تسوية الأرباح اليومية؟',
        faq6Desc: 'بعد اجتياز التحقق من PoRT تتم التسوية في اليوم التالي. يصدر النظام تلقائيًا مكافأة مزدوجة: أرباح USDT ونقاط 10x Deep.',
        faq7: 'كيف تُحتسب مكافأة الكاشف (Scout Bonus — مكافأة الإحالة المباشرة)؟',
        faq7Desc: 'عن كل حساب نشط تحيله مباشرة، تحصل على مكافأة يومية ثابتة: 1 USDT/يوم لإحالة حساب ALPHA (500 USDT)، و2 USDT/يوم لإحالة حساب SIGMA (1,000 USDT)، تستمر حتى انتهاء دورة ذلك الحساب.',
        faq8: 'كيف يتم الترقية بين المستويات (D1–D7)؟',
        faq8Desc: 'تتم الترقية وفق إجمالي حجم المنطقة الصغرى. مثلاً: D1 يتطلب 2,000 USDT، D3 يتطلب 15,000 USDT، وD7 (الأعلى) يتطلب 3,000,000 USDT. كلما ارتفع المستوى زادت مكافأة فرق المستويات (حتى 7 USDT/شخص/يوم في D7).',
        faq9: 'كم يومًا تستغرق الدورة الواحدة؟ ما الذي يحدث بعد انتهائها؟',
        faq9Desc: 'تستغرق الدورة الواحدة 28 يومًا. عند انتهاء الدورة يمكنك اختيار الاستمرار في الإيداع؛ تُدفع المكافآت بناءً على نتائج التحقق اليومي الفعلي من PoRT (عائد متغير).',
        faq10: 'هل هناك رسوم على السحب؟',
        faq10Desc:'السحب بدون رسوم. تعيد المنصة رسوم السحب إلى البركة لزيادة سيولة LP، مما يخلق دورة إيجابية.',
        bigArea: 'منطقة كبيرة',
        smallArea: 'منطقة صغيرة',
        enterWithdrawAmount: 'أدخل مبلغ السحب',
        all: 'الكل',
        available: 'متاح',
        totalAmount: 'المبلغ الإجمالي',
        confirmWithdraw: 'تأكيد السحب',
        withdrawRecord: 'سجل السحب',
        withdrawn: 'تم السحب',
        quickStartGuide:'دليل البدء السريع',
        whitepaperGuide:'الورقة البيضاء والدليل',
        whitepaper:' والدليل',
        downloadPdf:'تحميل'
    },
staking: {
    selectPackage: 'اشتراك في المصفوفة',
    alpha: 'ALPHA',
    beginner: 'مبتدئ',
    sigma: 'SIGMA',
    professional: 'محترف',
    popular: 'الأكثر شعبية',
    dailyReturn: 'مكافآت المهام ',
    teamDepth: 'عمق الفريق',
    limitPurchase: 'حد الشراء',
    layer: 'طبقة',
    copy: 'نسخة',
    autoRenew: 'تجديد تلقائي عند الانتهاء',
    autoReinvest: 'هامش التجديد التلقائي',
    subscribeAlpha: 'اشتراك Alpha',
    subscribeSigma: 'اشتراك Sigma',
    stakedAmount: 'الهامش',
    stakedAmount2: 'الفترة',
    stakedAmount3: 'الأرباح المتراكمة',
    stakingTime: 'وقت المشاركة',
    maturityTime: 'وقت الانتهاء',
    redeem: 'استرداد',
    renew: 'تجديد',
    autoRenewActive: 'تم التفعيل تلقائياً',
    autoRenewInactive: 'غير مفعل تلقائياً',
    smartContract: 'إدارة عبر العقد الذكي، يتم حجز الأموال لمدة 28الهامش وتفتح عند الانتهاء.',
     alter2:'إذا انتهت صلاحية التعهد، يرجى تجديده.',
},
me: {
    account: 'الحساب',
    my: 'حسابي',
    staked: 'تم  تجديد',
    staked1: 'الهامش',
    points: 'النقاط',
    consecutive: 'أيام متتالية',
    withdraw: 'سحب',
    language: 'اللغة',
    simplifiedChinese: 'الصينية المبسطة',
    disconnectWallet: 'قطع الاتصال بالمحفظة',
    level: 'المستوى',
    joinDate: 'تاريخ الانضمام',
    bdId: 'BD-ID'
},
bindapi: {
    apiBinding: 'ربط API',
    bindDesc: 'قم بربط مفاتيح API الخاصة بالبورصة للسماح بالتداول الكمي',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    exchange: 'البورصة',
    futures: 'العقود',
    spot: 'الفوري',
    readOnly: 'للقراءة فقط',
    bind: 'ربط',
    riskNote: 'مفاتيح API تستخدم فقط لمزامنة بيانات التداول ولا يتم تخزين معلومات حساسة',
    apiConnection: 'اتصال API',
    bindExchangeApi: 'ربط API البورصة',
    bitDeepRead: 'يقوم BitDeep بقراءة تدفق الأوامر من حساب CEX للتحقق من إثبات التداول الحقيقي (PoRT).',
    noWithdraw: 'لن نتعامل أبداً مع عمليات السحب الخاصة بك.',
    securityTip: 'نصيحة أمنية · يرجى القراءة بعناية',
    close: 'إغلاق',
    withdraw: 'سحب',
    permission: 'إذن',
    onlyEnable: 'تشغيل فقط',
    spotTrading: 'تداول فوري',
    read: 'قراءة',
    recommendedPartner: 'شريك موصى به',
    zeroFee: '0% رسوم',
    activated: 'مفعل',
    classicAccount: 'حساب كلاسيكي',
    unifiedAccount: 'حساب موحد',
    bindBitgetApi: 'ربط Bitget API',
    upcoming: 'قريباً',
    underAudit: 'قيد التدقيق',
    expected: 'متوقع'
},
port: {
    portTaskCenter: 'مركز مهام PORT',
    dailyTask: 'المهام اليومية',
    verify: 'تحقق',
    completed: 'مكتمل',
    incomplete: 'غير مكتمل',
    verifyStandard: 'معيار التحقق',
    tradingVolume: 'حجم التداول',
    today: 'اليوم',
    deadline: 'الموعد النهائي',
    reward: 'مكافأة',
    startVerify: 'ابدأ التحقق',
    verifying: 'جارٍ التحقق',
    verified: 'تم التحقق',
    insufficient: 'غير كافٍ',
    viewDetails: 'عرض التفاصيل',
    taskList: 'قائمة المهام',
    allTasks: 'كل المهام',
    completedTasks: 'مكتمل',
    pendingTasks: 'قيد الانتظار',
    proofOfRealTrading: 'إثبات التداول الحقيقي',
    todayTask: 'مهمة اليوم',
    todayStaticIncome: 'مكافآت مهام اليوم',
    points: 'النقاط',
    todayWindowClosesAt: 'نافذة اليوم تغلق عند',
    checkTaskStatus: 'تحقق من حالة المهمة',
    teamProgress: 'تقدم الفريق · اليوم',
    realtimePortCompletion: 'إكمال PORT في الوقت الفعلي',
    completedText: 'مكتمل',
    pendingText: 'قيد الانتظار',
    realtimeApiValidationFlow: 'الوقت الفعلي · API · تدفق التحقق',
    rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
},
internet: {
    network: 'الشبكة',
    treeBrowser: 'متصفح شجري',
    searchAddress: 'ابحث عن عنوان 0x... أو BD-ID',
    totalTradingVolume: 'إجمالي حجم التداول',
    members: 'الأعضاء',
    networkStructure: 'هيكل الشبكة',
    allLevels: 'كل المستويات',
    addRemark: 'إضافة ملاحظة',
    enterRemark: 'أدخل الملاحظة',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    alert1:'Share Performance',
    alert2:'Team Performance',
    alert3:'Task Status',
},
withdraw: {
    withdraw: 'سحب',
    usdtAsset: 'أصل USDT',
    withdrawAmount: 'مبلغ السحب',
    availableBalance: 'الرصيد المتاح',
    fee: 'رسوم',
    actualArrival: 'الوصول الفعلي',
    submit: 'إرسال',
    withdrawSuccess: 'تم السحب بنجاح',
    withdrawFailed: 'فشل السحب',
    processing: 'جارٍ المعالجة',
    completed: 'مكتمل',
    withdrawHistory: 'سجل السحب'
},
popup: {
    taskUnfinished: 'المهمة غير مكتملة',
    taskUnfinishedDesc: 'بيانات التداول لم تصل إلى معيار التحقق PoRT اليوم',
    todayTradingVolume: 'حجم تداول اليوم',
    remaining: 'المتبقي',
    toComplete: 'لإكمال مهمة اليوم',
    tradingVolumeThreshold: '',
    deadline: 'المتبقي حتى الموعد النهائي',
    tryAgain: 'حاول لاحقاً',
    goTrade: 'اذهب للتداول',
    taskCompleted: 'تم التحقق من المهمة',
    taskCompletedDesc: 'تم تسجيل إثبات التداول PoRT اليوم على البلوكشين بنجاح',
    rewardIssued: 'تم إصدار المكافأة',
    complete: 'مكتمل',
    shareTitle: 'دعوة للمشاركة',
    shareDesc: 'ادعُ الأصدقاء للتسجيل، وسيحصل الطرفان على مكافآت',
    referralLink: 'رابط الدعوة',
    qrCode: 'رمز QR',
    copyLink: 'نسخ الرابط',
    notask:'لا توجد مهام اليوم',
    notaskDesc:'لا توجد حالياً مهام تداول PoRT قيد المعالجة',
}
};
